import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import videoServices from 'services/video'
import AddGiosg from 'careers/components/add-giosg'
import Logo from 'components/logo'
import Video from 'components/video/video'
import Html from 'components/html/html'
import { mapLanguageToComponentProps } from 'i18n'
import { imagePath } from 'utils/image'
import ThirdPartyScripts from 'careers/components/third-party-scripts'
import { PageContent } from 'components/styled/page/page-content'
import ActionBarWrapper  from 'components/action-bar-wrapper'
import { Button } from 'components/styled/button'
import { Flex } from 'components/styled/containers/flex'
import { Box } from 'components/styled/containers/box'
import { Body } from 'components/styled/typography'
import { getPreviewActionBarRoot } from 'components/styled/page/preview-app-content'
import { formatDateTimeTimezone } from 'utils/date'

const propTypes = {
  company: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    jobAdDetails: PropTypes.object.isRequired,
  }).isRequired,
  jobAd: PropTypes.shape({
    description: PropTypes.string.isRequired,
    video: PropTypes.object,
    endTime: PropTypes.string,
  }).isRequired,
  openApplication: PropTypes.func.isRequired,
  context: PropTypes.string,
}

const defaultProps = {
  context: 'careers',
}

const DetailsContainer = styled(Flex)`
  column-gap: ${({ theme }) => theme.space.s32};

  ${({ theme }) => theme.mediaQuery.screenS} {
    flex-direction: column;
  }
`

function refreshPlaybackUrl(video, useOpentokPreview) {
  return videoServices.fetchPlaybackUrl(video, useOpentokPreview)
}

const VideoContainer = styled(Box)`
  height: 100%;
  width: 100%;
  flex: 1;
  flex-grow: 2;
`

const DetailsColumn = styled(Box)`
  flex: 1;
  flex-grow: 3;
`

export function JobAdDetails({
  i18n,
  jobAd,
  company,
  openApplication,
  context,
}) {
  const formattedDateTime =
    jobAd.endTime && formatDateTimeTimezone(jobAd.endTime)

  return (
    <>
      <PageContent size={jobAd.video && jobAd.video._id ? 'medium' : 'xSmall'}>
        {jobAd.logo && (
          <Flex mb="s16" mt="s16">
            <Logo logo={imagePath(jobAd.logo)} />
          </Flex>
        )}
        <DetailsContainer mt="s24">
          <DetailsColumn mb="s16">
            <Html html={jobAd.description} className="job-ad-description" />
          </DetailsColumn>
          {jobAd.video ? (
            <VideoContainer>
              <Video
                id={jobAd.video.id}
                title={jobAd.video.title}
                videoUrl={jobAd.video.videoUrl}
                playbackVideoUrl={jobAd.video.playbackVideoUrl}
                recorder={jobAd.video.recorder}
                refreshPlaybackUrl={useOpentokPreview =>
                  refreshPlaybackUrl(jobAd.video, useOpentokPreview)
                } // use url fetching so opentok videos play  before transported to other bucket
                locationId="jobAdDetailsPage"
                eventId="employerVideoPlayButton"
                videoEventProps={{
                  companyId: company._id,
                  companyName: company.name,
                  language: jobAd && jobAd.language,
                }}
              />
            </VideoContainer>
          ) : null}
        </DetailsContainer>
      </PageContent>
      <ActionBarWrapper
        getActionBarRoot={
          context === 'admin' ? getPreviewActionBarRoot : undefined
        }
        leftSideComponent={
          formattedDateTime && (
            <Body fontWeight={600}>
              {i18n.jobAdContainer.endTime(formattedDateTime)}
            </Body>
          )
        }
        actions={
          <Button
            icon="check"
            variant="primary"
            text={i18n.jobAdDetails.apply}
            onClick={openApplication}
            event={{
              locationId: 'jobAdDetailsPage',
              id: 'jobAdApplyButton',
              properties: {
                companyId: company._id,
                companyName: company.name,
                language: jobAd && jobAd.language,
              },
            }}
          />
        }
      />
      {context === 'careers' && (
        // TODO: Check if the Giosg chat bot could be removed at some point.
        // Was in use for one company but at the moment not in use I believe
        <>
          <AddGiosg enableGiosg={company.enableGiosg} />
          <ThirdPartyScripts />
        </>
      )}
    </>
  )
}

JobAdDetails.propTypes = propTypes
JobAdDetails.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(JobAdDetails)
